import { Link } from "react-router-dom";
import { formatRand, STOCK_NOTICE, mediaUrl } from "@/lib/api";
import { CalendarClock } from "lucide-react";

export const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="card-lift group block bg-white rounded-2xl border border-purple-100 overflow-hidden"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-gradient-to-br from-purple-50 to-fuchsia-50 flex items-center justify-center p-3">
        <img
          src={mediaUrl(product.images?.[0])}
          alt={product.name}
          className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-3 py-1 rounded-full text-[11px] font-semibold bg-white/90 text-purple-700 capitalize">
          {product.type}
        </span>
        {product.featured && (
          <span className="absolute top-3 right-3 px-3 py-1 rounded-full text-[11px] font-bold brand-gradient text-white">
            Featured
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-semibold text-gray-900 leading-snug line-clamp-1">{product.name}</h3>
        <div className="mt-1 flex items-center gap-1.5 text-[11px] text-emerald-600 font-medium">
          <CalendarClock className="w-3.5 h-3.5" />
          <span data-testid="stock-availability-notice">{STOCK_NOTICE}</span>
        </div>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-lg font-bold brand-gradient-text">{formatRand(product.price)}</span>
          <span className="text-xs text-purple-600 font-medium group-hover:underline">
            {product.colours?.length > 1 && (
              <span data-testid={`product-card-colours-${product.id}`} className="text-muted-foreground mr-2">{product.colours.length} colours</span>
            )}
            View →
          </span>
        </div>
      </div>
    </Link>
  );
};
